










































































































import {Component, Prop, Watch, Model} from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import {BusEvent} from '@/models/bus';

import SentenceLink from '../api/sentenceLink';
import Lesson from '../api/lesson';
import Exercise from '../api/exercise';
import ApiList from '@/api/list';

import Modal from '@/components/Modal.vue';
import DropDownEntity from '@/components/DropDownEntity.vue';
import FieldTextRange from '../components/FieldTextRange.vue';
import EditIcon from '../components/icons/EditIcon.vue';

@Component({
    components: {
        'modal': Modal,
        'drop-down-entity': DropDownEntity,
        'field-text-range': FieldTextRange,
        'edit-icon': EditIcon,
    },
})
export default class FieldSentenceLink extends CommonVue {
    @Model() public sentenceLinks!: SentenceLink[];
    @Prop({type: String}) public sentence!: string;
    @Prop({type: Boolean, default: false}) public disabled?: boolean;
    @Prop({type: Number}) public moduleId!: number;
    @Prop({type: Number}) public exerciseId!: number;

    public sentenceLink: SentenceLink = null;
    public showModal: boolean = false;
    public lessonList: ApiList<Lesson> = null;
    public exerciseList: ApiList<Exercise> = null;

    public async beforeMount() {
        this.busy = true;
        this.error = false;

        await this.loadLessonList();

        this.busy = false;
    }

    public async loadLessonList() {
        try {
            this.lessonList = await Lesson.getLessonsOfModule(this.moduleId);
        }
        catch (e) {
            this.$bus.$emit(BusEvent.ERROR, 'Could not load lessons list', e);
            this.error = true;
        }
    }

    @Watch('sentenceLink.lesson')
    public async loadExerciseList() {
        try {
            this.exerciseList = await Exercise.getExercisesOfLesson(this.sentenceLink.lesson);
        }
        catch (e) {
            this.$bus.$emit(BusEvent.ERROR, 'Could not load exercises list', e);
            this.error = true;
        }
    }
    
    public newSentenceLink() {
        this.sentenceLink = new SentenceLink();
        this.showModal = true;
    }
    
    public edit(sentenceLink: SentenceLink) {
        this.sentenceLink = sentenceLink;
        this.showModal = true;
    }

    public saveClicked() {
        if (!this.sentenceLink) {
            return;
        }

        this.busy = true;

        try {
            this.checkMandatoryFields();
            if (this.sentenceLink.state === 'created') {
                this.sentenceLinks.push(this.sentenceLink);
            }
            this.sentenceLink.state = 'updated';
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save sentence link', e);
        }
    }
    
    public checkMandatoryFields() {
        // Check if start index is filled
        if(this.sentenceLink.start_index === undefined || this.sentenceLink.start_index === -1) {
            throw Error('Please select a range for your sentenceLink.');
        }

        // Check if end index is filled
        if(this.sentenceLink.end_index === undefined || this.sentenceLink.end_index === -1) {
            throw Error('Please select a range for your sentenceLink.');
        }

        // Check if lesson is filled
        if(!this.sentenceLink.lesson) {
            throw Error('Please select a lesson for your sentenceLink.');
        }

        // Check if exercise is filled
        if(!this.sentenceLink.exercise) {
            throw Error('Please insert an exercise for your sentenceLink.');
        }
    }


    public deleteClicked() {
        this.sentenceLink.state = 'deleted';
        this.showModal = false;
    }
    
    public isValidExerciseList(): boolean {
        // if the lesson only has this exercise return not valid
        if (this.exerciseList.results.length === 1 && this.exerciseList.results[0].id === this.exerciseId){
            return false;
        }
        return this.exerciseList.results.length > 0;
    }
}
